import { Breadcrumb } from '@zoopla/listing-search-context';

const MAIN_SITE_LINK = 'https://www.zoopla.co.uk';

const SCHEMA_CONSTANTS = {
    ALTERNATE_NAME: 'Zoopla Property Search',
    SCHEMA: 'http://schema.org',
    NAME: 'Zoopla',
    WEBSITE: 'WebSite',
    WEBPAGE: 'WebPage',
    LIST_ITEM: 'ListItem',
    BREADCRUMB_LIST: 'BreadcrumbList',
    REAL_ESTATE_AGENT: 'RealEstateAgent',
    POSTAL_ADDRESS: 'PostalAddress',
    RESIDENCE: 'Residence',
    IMAGE_OBJECT: 'ImageObject',
    GEO: 'GeoCoordinates',
    PERSON: 'Person',
    PLACE: 'Place'
};

export const getBreadcrumbSchema = (
    canonicalPath: string,
    breadcrumbs?: Breadcrumb[]
) => {
    if (!breadcrumbs || breadcrumbs.length === 0) return undefined;
    const lastBreadCrumbUri = `${canonicalPath}`;
    const breadcrumbItems = breadcrumbs.map((breadcrumb, index) => {
        return {
            position: index + 1,
            item: {
                name: breadcrumb.label,
                '@id': `${MAIN_SITE_LINK}${breadcrumb.uri || lastBreadCrumbUri}`
            },
            '@type': SCHEMA_CONSTANTS.LIST_ITEM
        };
    });

    return {
        itemListElement: breadcrumbItems,
        '@type': SCHEMA_CONSTANTS.BREADCRUMB_LIST
    };
};

export const getJSONLD = (
    path: string,
    canonicalPath: string,
    breadcrumbs?: Breadcrumb[]
) => {
    return JSON.stringify(
        [
            {
                alternateName: SCHEMA_CONSTANTS.ALTERNATE_NAME,
                '@context': SCHEMA_CONSTANTS.SCHEMA,
                url: `${MAIN_SITE_LINK}/`,
                name: SCHEMA_CONSTANTS.NAME,
                '@type': SCHEMA_CONSTANTS.WEBSITE
            },
            {
                '@context': SCHEMA_CONSTANTS.SCHEMA,
                breadcrumb: getBreadcrumbSchema(canonicalPath, breadcrumbs),
                id: `${MAIN_SITE_LINK}${path}`,
                '@type': SCHEMA_CONSTANTS.WEBPAGE
            }
        ],
        null,
        '\t'
    );
};
